import { render, staticRenderFns } from "./LoadingProjectData.vue?vue&type=template&id=034968bc&scoped=true&"
import script from "./LoadingProjectData.vue?vue&type=script&lang=js&"
export * from "./LoadingProjectData.vue?vue&type=script&lang=js&"
import style0 from "./LoadingProjectData.vue?vue&type=style&index=0&id=034968bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034968bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
